export function findParentComponentByName( vm, find_name ) {
    let component = undefined
    let parent = vm.$parent
  
    while (parent && !component) {
      //console.log(parent.$options.name)
      if (parent.$options.name === find_name) {
        
        component = parent
      }
      parent = parent.$parent
    }
  
    return component
  }